import {planTypes ,trackingPlanTypes, WEBINAR_CATEGORY} from "@/common/constants";
import {get} from "lodash";
import { pageConfig } from '@/common/service/page-config';
import { mapGetters } from 'vuex';

const isMarketingWebinar100Enable = get(window, 'campaignFlags.isMarketingWebinar100Enable', true);

export default {
  key: planTypes['webinar'],
  data() {
    return {
      title: this.$t('billing.webinar.title'),
      subtitle: '',
      capacityKey: 'participants',
      planType: planTypes.WEBINAR,
      description: this.$t('billing.webinar.desc', ['10,000']),
      logo: require('@/assets/plans/webinar.svg'),
      totalLimitDesc: this.$t('billing.licences_limit_tips', ['Zoom Webinars', 'Zoom One']),
    }
  },
  computed: {
    ...mapGetters(['enableWebinar300', 'enableOnlineRemoveWebinar10000']),
    supportCapacity() {
      return [
        (isMarketingWebinar100Enable && pageConfig.from === WEBINAR_CATEGORY.webinar100) ? 100 : null,
        this.enableWebinar300 ? 300 : null,
        500,1000,3000,5000,10000
      ].filter(Boolean);
    },
    trackingPlanKey() {
      return get(trackingPlanTypes, get(planTypes, this.planType));
    },
  },
  watch: {
    enableOnlineRemoveWebinar10000: {
      handler(newVal) {
        this.description = this.$t('billing.webinar.desc', [newVal ? '5,000' : '10,000']);
      },
      immediate: true
    }
  }
};
